import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { keywordsActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import ChipInput from 'material-ui-chip-input'
import { readOnly } from '../../utils/permissions'
import Chip from '@material-ui/core/Chip'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = keyword => {
    const { onClose, addKeyword, editKeyword, changeMessage } = this.props
    if (keyword._id) {
      editKeyword(keyword).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addKeyword(keyword).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }
  handleSubmit = (e, keyword) => {
    e.preventDefault()
    const { setKeywordFormTouched } = this.props

    if (this.props.keywordFormErrors.valid) {
      this.handleSave(keyword)
    } else {
      setKeywordFormTouched()
    }
    return false
  }
  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  handleAddSinonimo = sinonimo => {
    const { keyword = '' } = this.props
    let sinonimos = keyword.sinonimos ? keyword.sinonimos.split(',') : []

    const duplicated = sinonimos.find(
      item => item.trim().toLowerCase() === sinonimo.trim().toLowerCase()
    )

    sinonimos = duplicated ? sinonimos : [...sinonimos, sinonimo]

    this.props.handleChangeKeyword({ ...keyword, sinonimos: (sinonimos || []).join(', ') })
  }

  handleDeleteSinonimo = sinonimo => {
    const { keyword = '' } = this.props
    let sinonimos = (keyword.sinonimos || '').split(',')

    sinonimos = sinonimos.filter(item => item !== sinonimo)

    this.props.handleChangeKeyword({ ...keyword, sinonimos: (sinonimos || []).join(', ') })
  }
  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      keyword,
      handleChangeKeyword,
      loadingKeyword,
      keywordFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('palavrasChave', token)

    return (
      <div>
        <Dialog
          modalId={keyword._id ? 'palavras-chave-editar' : 'palavras-chave-nova'}
          modalParams={{ registro: keyword._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingKeyword ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(keyword._id ? 'palavras-chave-editar' : 'palavras-chave-nova') + '-title'}>
                {isReadOnly ? (
                  'Palavra-chave'
                ) : (
                  <Fragment>
                    {keyword._id ? 'Editar palavra-chave' : 'Cadastrar palavra-chave'}
                  </Fragment>
                )}
              </DialogTitle>
              <DialogContent>
                <form
                  id={'keyword-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, keyword)
                  }}
                >
                  <FormControl
                    error={!((keywordFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Palavra-chave</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeKeyword({ ...keyword, nome: e.target.value })
                      }}
                      value={keyword.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((keywordFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((keywordFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((keywordFormErrors.fields || {})['sinonimos'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <ChipInput
                      disabled={isReadOnly}
                      id="field-sinonimos"
                      value={keyword.sinonimos ? keyword.sinonimos.split(',') : []}
                      label={'Sinônimos'}
                      inputProps={{
                        form: 'non-form'
                      }}
                      onAdd={this.handleAddSinonimo}
                      onDelete={this.handleDeleteSinonimo}
                      chipRenderer={(
                        {
                          value,
                          text,
                          isFocused,
                          isDisabled,
                          handleClick,
                          handleDelete,
                          className
                        },
                        key
                      ) => (
                        <Chip
                          key={key}
                          className={className}
                          style={{
                            pointerEvents: isDisabled ? 'none' : undefined,
                            backgroundColor: isFocused ? 'black' : undefined
                          }}
                          onClick={handleClick}
                          onDelete={isDisabled ? null : handleDelete}
                          label={text}
                        />
                      )}
                    />
                    {!((keywordFormErrors.fields || {})['sinonimos'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((keywordFormErrors.fields || {})['sinonimos'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'keyword-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    keyword: state.keywords.keyword,
    loadingKeyword: state.keywords.loadingKeyword,
    keywordFormErrors: state.keywords.keywordFormErrors,
    formTouched: state.keywords.keywordFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(keywordsActions.openModal())
    },
    closeModal: () => {
      dispatch(keywordsActions.closeModal())
    },
    handleChangeKeyword: keyword => {
      dispatch(keywordsActions.handleChangeKeyword(keyword))
    },
    addKeyword: keyword => {
      return dispatch(keywordsActions.addKeyword(keyword))
    },
    editKeyword: keyword => {
      return dispatch(keywordsActions.editKeyword(keyword))
    },
    setKeywordFormTouched: keyword => {
      dispatch(keywordsActions.setKeywordFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Keywords/EditModal.js